<template>
    <b-modal :static="true" :no-enforce-focus="true"  size="lg" :title="modalTitle" hide-footer id="scanOrderModal">
        <b-overlay :show="busyLoading || !hasMounted">
            <div class="modal-body" style="width: 100%;">
                <b-container fluid>
                    <b-row v-show="currentAction == 'scan'">
                        <b-col>
                            <div v-if="scanningOn" style="text-align: center;" class="col-sm-12">
                                <video height="350px" width="350px" id="qrScanX42"></video>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-if="currentAction == 'view'">
                        <b-col>
                            <h4>Client: {{ scannedOrder.client_name }}</h4>
                            <h4>Contact Person: {{ scannedOrder.contact_person }}</h4>
                            <h4>Order No: {{ scannedOrder.order_no }}</h4>
                            <h4>Current Status:
                                <b-button
                                    size="sm"
                                    style="pointer-events: none;"
                                    variant="primary"
                                    pill
                                    class=""
                                >
                                    {{ scannedOrder.status.name }}
                                </b-button>
                            </h4>
                        </b-col>
                    </b-row>
                    <b-row v-if="currentAction == 'update'">
                        <b-col>
                            <h4>Client: {{ scannedOrder.client_name }}</h4>
                            <h4>Contact Person: {{ scannedOrder.contact_person }}</h4>
                            <h4>Order No: {{ scannedOrder.order_no }}</h4>
                            <b-form>
                                <b-form-group id="input-group-3" label="Select New Order Status:" label-for="input-3">
                                    <b-form-select id="input-3" v-model="currentStatusId" :options="orderStatuses"></b-form-select>
                                </b-form-group>
                            </b-form>
                        </b-col>
                    </b-row>
                    <b-row>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" @click="saveOrderStatus()" v-show="statusChanged && currentAction == 'update'">Save</button>
                            <button type="button" class="btn btn-primary" @click="viewOrder()" v-show="currentAction == 'view'">View Order</button>
                            <button type="button" class="btn btn-danger" @click="updateStatus()" v-show="currentAction == 'view'">Update Status</button>
                            <button type="button" class="btn btn-secondary" @click="hideModal()">Close</button>
                        </div>
                    </b-row>
                </b-container>
            </div>
        </b-overlay>
    </b-modal>
</template>
<script>
import { adminComputed, orderComputed, orderMethods } from "@/state/helpers";
let qrScan = null;
import QrScanner from 'qr-scanner';
export default {
    data: () => ({
        scanningOn: false,
        orderNumber: "",
        busyLoading: false,
        hasMounted: false,
        currentAction: 'scan',
        currentStatusId: -1, 
        orderIndex: -1
    }),
    computed: {
        ...adminComputed,
        ...orderComputed,
        modalTitle() {
            if (this.currentAction == 'scan') {
                return 'Scan Order';
            }
            return "Manage Order " + this.scannedOrder.order_no;
        },
        orders() {
            return this.branch_orders;
        },
        scannedOrder() {
            if (this.orderIndex > -1) {
                return this.orders[this.orderIndex];
            }
            return {};
        },
        statusChanged() {
            if (Object.keys(this.scannedOrder).length > 0 && (this.currentStatusId != this.scannedOrder.status.id)) {
                return true;
            }
            return false;
        },
        orderStatuses() {
            const currentOrder = this.scannedOrder?.status.order;
            if (currentOrder !== undefined) {
                const transformedArray = this.order_statuses
                    .filter(status => status.order >= currentOrder)
                    .map(status => ({
                        value: status.id,
                        text: status.name
                    }));

                return transformedArray
            }
            return [];
        }

    },
    methods: {
        ...orderMethods,
        viewOrder() {
            let idForUrl = this.scannedOrder.id;
            this.setSelectedOrder(idForUrl);
            this.$router.push({
                path: `/orders/view/order/${idForUrl}`,
            });
        },
        updateStatus() {
            this.currentStatusId = this.scannedOrder.status.id;
            this.currentAction = "update";
        },
        saveOrderStatus() {
            const statusName = this.order_statuses.find(status => status.id === this.currentStatusId)?.name;
            this.$swal
                .fire({
                    title: "Update Order Status",
                    text: "Change order status to: " + statusName,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes",
                })
                .then((result) => {
                    if (result.value) {
                        this.busyLoading = true;
                        let params = {
                            order_id: this.scannedOrder.id,
                            status_id: this.currentStatusId,
                        };
                        this.updateExternalOrderStatus(params).then(() => {
                            this.$emit('reload-event');
                            this.hideModal();
                        });
                    }
                });
        },
        initQrScanner() {
            //eslint-disable-next-line
            console.log("hit init");
            this.$nextTick(() => {
                const videoElem = document.getElementById('qrScanX42');
                if (qrScan == null) {
                    qrScan = new QrScanner(
                        videoElem,
                        (result) => this.findOrder(result),
                        { returnDetailedScanResult: true },
                    );
                }
                if (window.currentOS == "android") {
                    if (!document.fullscreenElement) {
                        document.documentElement.requestFullscreen();
                    }
                    screen.orientation.lock(window.screen.orientation.type);
                }
                qrScan.start();
            });
        },
        async findOrder(orderToken) {
            //eslint-disable-next-line
            console.log("set order", orderToken);
            let scanResult = orderToken.data;
            if (scanResult.length > 0) {
                try {
                    await qrScan.stop();
                    this.busyLoading = true;
                    let findIndex = this.orders.findIndex(function (o) { return o.order_no == scanResult; });
                    if (findIndex > -1) {
                        //eslint-disable-next-line
                        console.log("found index", findIndex);
                        this.orderIndex = findIndex;
                        this.currentAction = 'view';
                        this.busyLoading = false;
                        //eslint-disable-next-line
                        console.log("set order", this.scannedOrder);
                    } else {
                        this.busyLoading = false;
                        qrScan.start();
                    }
                } catch (e) {
                    //eslint-disable-next-line
                    console.error('A disturbance in the Force was encountered:', e);
                }
            }
        },
        hideModal() {
            this.$bvModal.hide("scanOrderModal");
        },
    },
    created() {
        if (this.order_statuses.length == 0) {
            this.getOrderStatuses();
        }
    },  
    mounted() {
        this.$root.$on('bv::modal::shown', () => {
            //eslint-disable-next-line
            console.log("firing show hook");
            qrScan = null;
            this.hasMounted = true;
            this.busyLoading = false;
            this.scanningOn = true;
            this.$nextTick(() => {
                this.initQrScanner();
            });
        });
        this.$root.$on('bv::modal::hidden', () => {
            //eslint-disable-next-line
            console.log("firing hook");
            if (window.currentOS == "android") {
                screen.orientation.unlock();
            }
            qrScan.stop();
            qrScan.destroy();
            this.scanningOn = false;
            this.orderIndex = -1;
            this.currentAction = 'scan';
        });
    },
    beforeDestroy: function() {
        if (qrScan != null) {
            qrScan.stop();
            qrScan.destroy();
            qrScan = null;
        }
        this.$root.$off('bv::modal::shown');
        this.$root.$off('bv::modal::hidden');
    }
};
</script>